












import { defineComponent, PropType } from "vue";
export default defineComponent({
  name: "AccountListItem",
  components: {},
  props: {
    account: { type: Object as PropType<Account.Info>, required: true },
    selected: { type: Boolean, default: false }
  }
});
